import { AppHeader, useAppId } from "../components/app-header";
import { FixesList } from "../components/issues";

/** Issues created from Metrickle and whether closing them moved the metric they were about. */
export function Fixes() {
  const appId = useAppId();
  return (
    <>
      <AppHeader
        title="Fixes"
        subtitle="Issues created from feedback, hotspots, tasks and cases. 7 days after one is closed, Metrickle compares its metric with the 7 days before it was opened."
      />
      <div className="max-w-4xl">
        <FixesList appId={appId} />
      </div>
    </>
  );
}
